import ExcelJS from 'exceljs';
import TGButton from 'src/components/ui/TGButton';
import DownloadIcon from 'src/components/ui-icons/upload/DownloadIcon';
import { ReportDoneMonth } from '../../types/reportDone5SAudit';

interface Props {
  months: ReportDoneMonth[];
}

const capitalize = (s: string) => (s ? s[0].toUpperCase() + s.slice(1) : s);

const calcPercent = (plan: number, fact: number) =>
  plan > 0 ? `${Math.round((fact / plan) * 100)}%` : '0%';

const ExportToExcelReportDone: React.FC<Props> = ({ months }) => {
  const isEmpty = !months || months.length === 0;

  const exportExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('Выполнение 5S');
      sheet.properties.defaultRowHeight = 20;

      sheet.columns = [
        { header: 'Год', key: 'year', width: 8 },
        { header: 'Месяц', key: 'month', width: 14 },
        { header: 'Локация', key: 'location', width: 22 },
        { header: 'Подразделение', key: 'department', width: 22 },
        { header: 'Участок', key: 'area', width: 18 },
        { header: 'Зона', key: 'zone', width: 22 },
        { header: 'Тип аудита', key: 'typeAudit', width: 16 },
        { header: 'План', key: 'plan', width: 10 },
        { header: 'Факт', key: 'fact', width: 10 },
        { header: '%', key: 'percent', width: 10 },
      ];

      months.forEach((m) => {
        m.locations.forEach((loc) => {
          loc.departments.forEach((dep) => {
            dep.areas.forEach((area) => {
              if (area.cross) {
                sheet.addRow({
                  year: m.year,
                  month: capitalize(m.monthName),
                  location: loc.locationName,
                  department: dep.departmentName,
                  area: area.areaName,
                  zone: '',
                  typeAudit: 'Перекрестный',
                  plan: area.cross.plan,
                  fact: area.cross.fact,
                  percent: calcPercent(area.cross.plan, area.cross.fact),
                });
              }
              area.zones.forEach((z) => {
                sheet.addRow({
                  year: m.year,
                  month: capitalize(m.monthName),
                  location: loc.locationName,
                  department: dep.departmentName,
                  area: area.areaName,
                  zone: z.zone,
                  typeAudit: 'Внутренний',
                  plan: z.plan,
                  fact: z.fact,
                  percent: calcPercent(z.plan, z.fact),
                });
              });
            });
          });
        });
      });

      sheet.getRow(1).font = { size: 12, bold: true };
      sheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      sheet.getRow(1).height = 28;

      sheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' },
          };
          if (rowNumber > 1) {
            cell.font = { size: 11 };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
          }
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Выполнение_5S.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Ошибка при экспорте 5S отчета:', error);
    }
  };

  return (
    <TGButton
      icon={<DownloadIcon />}
      color='white'
      size='small'
      className='p-3'
      onClick={exportExcel}
      disabled={isEmpty}
    >
      Скачать в Excel
    </TGButton>
  );
};

export default ExportToExcelReportDone;
